


































































































































import { Vue, Component } from "vue-property-decorator";
import * as http from "@/common/http";
@Component
export default class ContactUs extends Vue {
  emailName:string = '';
  emailFrom:string = '';
  emailTel:string = '';
  emailSubject:string = '';
  emailDetails:string = '';
  emailError:string = '';

  sending:boolean = false;
  emailSent:boolean = false;

  get hasAllInput() : boolean {
    let n = this.emailName ? this.emailName.trim() : null;
    let f = this.emailFrom ? this.emailFrom.trim() : null;
    let t = this.emailTel ? this.emailTel.trim() : null;
    let s = this.emailSubject ? this.emailSubject.trim() : null;
    let d = this.emailDetails ? this.emailDetails.trim() : null;
    return !!(n && f && t && s && d);
  }

  get hasInput() : boolean {
    return !!(this.emailName || this.emailFrom || this.emailTel ||
           this.emailSubject || this.emailDetails);
  }

  async sendEmail() {
    try {
      let data:any = {
        email_name: this.emailName,
        email_from: this.emailFrom,
        email_tel: this.emailTel,
        email_subject: this.emailSubject,
        email_details: this.emailDetails.replace(/\n/g,'<br/>'),
        action: '__send_'
      };
      this.sending = true;
      data = await http.request(http.APP_URL + '/contactus.jsp',{
        method: 'POST',
        body: JSON.stringify(data)
      });
      this.sending = true;
      this.emailSent = true;
    } catch (error) {
      this.emailSent = false;
      this.sending = false;
      this.emailError = error.message || 'ส่งอีเมล์ขัดข้อง โปรดลองส่งมาใหม่อีกครั้ง'
    }
  }

  resetForm() {
    this.emailName  = '';
    this.emailFrom  = '';
    this.emailTel  = '';
    this.emailSubject  = '';
    this.emailDetails  = '';
    this.emailError = '';
  }
}
